<script>
export default {
  name: "BaseSubContent",
  props: {
    header: {
      type: String,
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-2 text-sm">
    <h5
      v-if="$slots.header || header"
      class="font-condensed font-semibold uppercase tracking-wide text-green-100"
    >
      <slot v-if="$slots.header" name="header" />
      <span v-else>{{ header }}</span>
    </h5>

    <slot />
  </div>
</template>

<style scoped></style>
